export default "__VITE_ASSET__DKJDRqar__"